import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

export const actionTypes = {
    SetTempChecklist: "[SetTempChecklist] Action",
    ClearTempChecklist: "[ClearTempChecklist] Action",
};

const initialTempDataState = {
    checklistData: null,
};

export const reducer = persistReducer(
    { storage, key: "app-temp-data", whitelist: ["checklistData"] },
    (state = initialTempDataState, action) => {
        switch (action.type) {
            case actionTypes.SetTempChecklist: {
                return {
                    ...state,
                    checklistData: action.payload.checklistData,
                };
            }

            case actionTypes.ClearTempChecklist: {
                return {
                    ...state,
                    checklistData: null,
                };
            }

            default:
                return state;
        }
    }
);

export const actions = {
    setTempChecklistData: (checklistData) => ({ type: actionTypes.SetTempChecklist, payload: { checklistData } }),
    clearTempChecklistData: () => ({ type: actionTypes.ClearTempChecklist }),
};